export enum TrainingRequestType {
  Employee,
  Manager,
}

export const TrainingRequestTypeOptions = [
  { id: TrainingRequestType.Employee, name: 'Employee' },
  { id: TrainingRequestType.Manager, name: 'Manager' },
];
